import {
  takeLatest,
  all,
  fork,
  call,
  put,
} from 'redux-saga/effects'
import {
  FETCH_PARTS,
  POST_PARTS,
} from './constants'
import T from 'i18n-react'
import {
  updateParts,
  updatePartData,
  updateEditValue,
  updateLastUpdated,
  updateLoadingPart,
  fetchPartsStart,
  fetchPartsSuccess,
  fetchPartsError,
  startFetchPartsAsync,
  postPartsStart,
  postPartsSuccess,
  postPartsError,
} from './actions'
import { success, error } from 'containers/App/Notification/actions'

import {
  getRequest,
  postRequest,
} from 'helpers/RequestUtil'
import {
  buildUrl,
} from 'helpers/actionHelper'
 

function* fetchParts(url) {
  try {
    yield put(startFetchPartsAsync())
    yield put(fetchPartsStart())
    const data = yield call(
      getRequest,
      url
    )
    yield put(fetchPartsSuccess())
    return data
  } catch(error) {
    yield put(fetchPartsError(error))
  }
}

function* postParts(url, partName, partData, partSettingName) {
  try {
    yield put(postPartsStart())
    yield put(updateLoadingPart(partName, true))
    if (partSettingName) yield put(updateLoadingPart(partSettingName, true))
    partData = JSON.stringify(partData)
    const data = yield call(
      postRequest,
      'parts',
      { partName, partData },
      url
    )
    yield put(success(T.translate('pages.admin.partsLibrary.notification.post_success')))
    yield put(postPartsSuccess())
    return data
  } catch(error) {
    yield put(postPartsError(error))
  } finally {
    yield put(updateLoadingPart(partName, false))
    if (partSettingName) yield put(updateLoadingPart(partSettingName, false))
  }
}

function* handleFetchParts() {
  const url = buildUrl('/api/fulcrum/admin/parts')
  const { data } = yield call(fetchParts, url)
  yield put(updateParts(data.partData))
  yield all(Object.keys(data.lastUpdated).map(partName => 
    put(updateLastUpdated(partName, data.lastUpdated[partName]))
  ))
}

function* handlePostParts(action) {
  const { partName, partData, partSettingName } = action
  const url = buildUrl('/api/fulcrum/admin/parts')
  const data = yield call(postParts, url, partName, partData, partSettingName)
  if (data && data.data) {
    yield put(updatePartData(partName, partData))
    yield put(updateEditValue(partName, false))
    if (partSettingName) yield put(updateEditValue(partSettingName, false))
    yield put(updateLastUpdated(partName, data.data.lastUpdated))
  } 
}

function* watchPostParts() {
  yield takeLatest(POST_PARTS, handlePostParts)
}

function* watchFetchParts() {
  yield takeLatest(FETCH_PARTS, handleFetchParts)
}

function* loadSagas() {
  yield all([
    fork(watchPostParts),
    fork(watchFetchParts),
  ])
}

export default loadSagas
